import { useEffect, useState } from 'react';

import { fetchStateComplianceDisclaimers, type StateComplianceDisclaimer } from '@/modules/api';

type UseStateComplianceDisclaimers = {
  disclaimers: StateComplianceDisclaimer[];
  isLoading: boolean;
  error: unknown;
};

export function useStateComplianceDisclaimers(): UseStateComplianceDisclaimers {
  const [disclaimers, setDisclaimers] = useState<StateComplianceDisclaimer[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let cancelled = false;
    fetchStateComplianceDisclaimers()
      .then((items) => {
        if (cancelled) return;
        setDisclaimers(items);
        setIsLoading(false);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err);
        setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { disclaimers, isLoading, error };
}
